import React, { Component } from 'react';
import './style.css';
import { translate } from 'react-i18next';

class End extends Component {
  constructor(props) {
    super(props);
    this.state = {
      interview: JSON.stringify(props.state.output, null, 4),
      response: ''
    };
    this.sendData = this.sendData.bind(this);
  }

  sendData() {
    const payload = {
      method: 'POST',
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(this.props.state.output)
    };

    fetch(
      process.env.REACT_APP_API_URL + '/backend/interview/api/create/',
      payload
    )
      .then(function(response) {
        return response.json();
      })
      .then(
        function(json) {
          this.setState({ response: json['id'] });
        }.bind(this)
      )
      .catch(function(ex) {
        console.log('parsing failed', ex);
      });
  }

  componentDidMount() {
    this.sendData();
  }

  render() {
    const { t } = this.props;
    let message = t('Your results are being submitted!');
    if (this.state.response) {
      message = t('Your interview ID is') + ': ' + this.state.response;
    }
    return (
      <div className="card-body text-center">
        <div className="question">{t('Thank you for participating')}</div>
        <div className="instructions text-muted">{message}</div>
      </div>
    );
  }
}

export default translate('translations')(End);



// WEBPACK FOOTER //
// ./src/comparison-new/components/End/index.js